import { render, staticRenderFns } from "./CompleteTable.vue?vue&type=template&id=8f4bb710&"
import script from "./CompleteTable.vue?vue&type=script&lang=js&"
export * from "./CompleteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports